export default {
        "edgeComputing_getBatchEdgeComputingRules": "search EdgeComputing success",
}